var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.807,
    height: 15.807,
    viewBox: "0 0 15.807 15.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7209.012 -8045.438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7219.193,8049.857l3.982-3.865,3.2,3.163-4.8,4.527-2.967-3.318Z",
    transform: "translate(-1.934 -0.082)",
    fill: "#fff5e9",
    stroke: "#707070",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7219.193,8049.857l3.982-3.865,3.2,3.163-4.8,4.527-2.967-3.318Z",
    transform: "translate(-9.091 7.075)",
    fill: "#fff5e9",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7209.162 8045.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.486,11.471a1,1,0,0,0,0,1.418l1.132,1.132a1,1,0,0,0,1.418,0l2.828-2.828a1,1,0,0,0,0-1.418L5.732,8.643a1,1,0,0,0-1.418,0L1.486,11.471Zm-.843-.844L3.471,7.8a2.195,2.195,0,0,1,3.105,0L7.707,8.931a2.195,2.195,0,0,1,0,3.105L4.88,14.864a2.195,2.195,0,0,1-3.105,0L.644,13.733a2.195,2.195,0,0,1,0-3.105ZM13.733.644l1.131,1.131a2.195,2.195,0,0,1,0,3.105L12.037,7.707a2.195,2.195,0,0,1-3.105,0L7.8,6.576a2.195,2.195,0,0,1,0-3.105L10.628.644a2.195,2.195,0,0,1,3.105,0ZM8.643,5.732,9.775,6.864a1,1,0,0,0,1.418,0l2.828-2.828a1,1,0,0,0,0-1.418L12.889,1.486a1,1,0,0,0-1.418,0L8.643,4.314a1,1,0,0,0,0,1.418Z",
    transform: "translate(0 0)",
    fill: "#0c4767",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.182,5.8a.579.579,0,0,1,0-.843L4.954.182a.579.579,0,0,1,.843,0,.579.579,0,0,1,0,.843L1.025,5.8a.589.589,0,0,1-.419.182A.6.6,0,0,1,.182,5.8Z",
    transform: "translate(4.771 4.764)",
    fill: "#fd9926",
    stroke: "#fff",
    strokeWidth: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.a59d24b3ac46fd773dd9cdfff0362029.svg";
export { ForwardRef as ReactComponent };